import React from 'react';

import * as DateUtil from 'util/DateUtil';

interface TimestampProps {
  creator?: {
    name: string;
    email: string;
    handle: string;
    url_identifier: string;
  };
  isodate?: string;
}

class Timestamp extends React.PureComponent<TimestampProps> {
  override render(): JSX.Element {
    const date = this.props.isodate;
    return (
      <div className="mediocre-row-timestamp">
        {this.props.creator ? (
          <div className="text-right">
            <a
              className="mediocre-row-timestamp-author u-ellipsis-text"
              href={`/${this.props.creator.url_identifier}/`}
              rel="noopener noreferrer"
              target="_blank"
              title={`${this.props.creator.name} <${this.props.creator.email}>`}
            >
              {this.props.creator.handle}
            </a>
            <p
              className="mediocre-row-timestamp-time"
              title={DateUtil.readableTime(date, {showYear: true, showTime: true, showWeekday: true})}
            >
              {DateUtil.readableTime(date)}
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Timestamp;
